import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: 25
    },
    commentTextarea: {
      "& label.MuiFormLabel-root": {
        fontSize: 14
      },
      "& .MuiInputBase-root": {
        borderRadius: 3,
        color: primary.main,
        paddingBottom: 22
      },
      "& .MuiInputBase-input": {
        maxHeight: 136,
        overflowY: "auto !important"
      },
      "& .Mui-focused fieldset": {
        borderWidth: 1
      }
    },
    buttons: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    controlButtons: {
      display: "flex",
      gap: 22,
      marginLeft: 8,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        gap: 0
      }
    },
    button: {
      fontSize: 16,
      color: primary.dark,
      height: 32,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        fontSize: 14
      }
    },
    saveButton: {
      color: secondary.dark
    },
    warningText: {
      display: "block"
    },
    loader: {
      height: 99
    },
    warningButton: {
      display: "flex",
      alignItems: "center",
      fontSize: 14,
      height: 24,
      margin: "4px 0",
      padding: "0 10px",
      backgroundColor: theme.palette.common.white,
      border: "1px solid rgba(0, 0, 0, 0.23)",
      borderRadius: 4,
      whiteSpace: "nowrap",
      "&:hover": {
        cursor: "pointer"
      },
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        fontSize: 12
      },
      "& > *": {
        color: theme.palette.primary.dark
      },
      "&.active": {
        backgroundColor: "#ff7e00",
        border: "1px solid transparent",
        "&:hover": {
          backgroundColor: "#ffac59"
        },
        "& > *": {
          color: theme.palette.common.white
        }
      }
    }
  };
});
